import * as THREE from 'three'
let TWEEN = require('@tweenjs/tween.js')
let tani = {t: 0.1}
class Scene3 {
  constructor (loadmodel) {
    let s1 = loadmodel.scene.getObjectByName('s1')
    let s2 = loadmodel.scene.getObjectByName('s2')
    loadmodel.models = new THREE.Scene()
    loadmodel.models.add(s1)
    loadmodel.models.add(s2)
    loadmodel.scene.remove(s1)
    loadmodel.scene.remove(s2)
    let s3 = loadmodel.scene.getObjectByName('s3')
    s3.visible = true
    var html = document.getElementById('white')
    var dis_ = loadmodel.tween(html.style).to({opacity: 0}, 800).easing(TWEEN.Easing.Quartic.In)
    dis_.start()
    // 清场
    let splineCamera = loadmodel.scene.getObjectByName('s3_camera')
    let tube = loadmodel.scene.getObjectByName('s3_line_in')
    let tubeGeometry = tube.geometry
    loadmodel.camera = splineCamera
    let that = this
    var go = loadmodel.tween(tani).to({t: 0.99}, 1500).easing(TWEEN.Easing.Exponential.Out)
    go.start()
    loadmodel.sceneupdate = function () {
      if (tani.t < 0.99) {
        let pos = tubeGeometry.parameters.path.getPointAt(tani.t)
        let lookat = tubeGeometry.parameters.path.getPointAt(tani.t + 0.01)
        this.camera.position.copy(pos)
        this.camera.lookAt(lookat)
      } else {
        that.StartTouch(loadmodel)
        that.NextScene(loadmodel)
        document.getElementById('close1').addEventListener('click', function (e) {
          e.preventDefault()
          this.parentNode.style.display = 'none'
          //console.log(document.getElementById('scene_1').childNodes)
        })
      }
    }
  }

  Popup (loadmodel) {
    var s1tishi1 = document.getElementById('s1_tishi_1')
    var scene1tan = document.getElementById('scene_1')
    s1tishi1.style.display = 'block'
    s1tishi1.style.opacity = 0
    var blo1 = loadmodel.tween(s1tishi1.style).to({opacity: 1}, 2000).easing(TWEEN.Easing.Quartic.In).onStart(function () {
      // console.log('daafasdfaseawe234234234234')
      var str = '从中山装到喇叭裤风靡流行,<br>朴素的衣装多了明艳色彩,<br>"三转一响"成为新婚必备的彩礼,<br>八十年代尽显春暖花开新气象。'
      var text1 = document.getElementById('text_1')
        // console.log(str.length)
      let i = 0
      let timer = setInterval(function () {
        if (i <= str.length) {
          text1.innerHTML = str.slice(0, i++) + '|'
        } else {
          clearInterval(timer)
          text1.innerHTML = str
        }
      }, 30)
    }).onComplete(function () {
      let touchstart = function () {
          // // console.log('小时')
        s1tishi1.style.display = 'none'
        window.removeEventListener('touchstart', touchstart, false)
        window.removeEventListener('click', touchstart, false)
      }
      window.addEventListener('touchstart', touchstart, false)
      window.addEventListener('click', touchstart, false)
    })
    blo1.start()
    let raycaster = new THREE.Raycaster()
    let door = loadmodel.scene.getObjectByName('s3_door')
    let list = []
    for (var i = 0; i < 4; i++) {
      list.push(loadmodel.scene.getObjectByName('s3_dian' + i))
    }
      // console.log(list)
    let touchend = function (e) {
      let mouse = new THREE.Vector2()
      mouse.x = (e.x / window.innerWidth) * 2 - 1
      mouse.y = -(e.y / window.innerHeight) * 2 + 1
      raycaster.setFromCamera(mouse, loadmodel.camera)
      let intersects = raycaster.intersectObject(door)
      if (intersects.length > 0) {
          // console.log('场景1到场景2')
        loadmodel.tweenClear()
        loadmodel.EndControls()
          // console.log(loadmodel)
        loadmodel.stats = 's3_1'
        container.removeEventListener('click', clickFun, false)
      }
      for (var j = 0; j < list.length; j++) {
        let intersects = raycaster.intersectObject(list[j])
        if (intersects.length > 0) {
          // console.log(j)
          scene1tan.style.display = 'block'
          var len = scene1tan.getElementsByTagName('li')
          // console.log(len)
          for (var i = 0; i < len.length; i++) {
            len[i].style.display = 'none'
          }
          scene1tan.style.pointerEvents = 'auto'
          scene1tan.getElementsByTagName('li')[j].style.display = 'block'
        }
      }
    }
    let clickFun = function (event) {
      let point = new THREE.Vector2()
      point.x = event.clientX
      point.y = event.clientY
      touchend(point)
    }
    let container = document.getElementById('container')
    container.addEventListener('click', clickFun, false)
    // container.removeEventListener('click', clickFun, false)
  }

  StartTouch (loadmodel) {
    let _lookat = loadmodel.scene.getObjectByName('s3_lookat_1')
    loadmodel.ChangeControls(_lookat.position)
    loadmodel.sceneupdate = function () {}
  }

  NextScene (loadmodel) {
    let pano = new THREE.Group()
    loadmodel.scene.add(pano)
    pano.name = 's4'
    let lookat = loadmodel.scene.getObjectByName('s4_lookat_1')
    let lookat__ = loadmodel.scene.getObjectByName('s4_radis_3')
    let r = Math.abs(lookat.position.y - lookat__.position.y)
    let position = lookat.position

    // 添加点
    let dianMaterial = new THREE.MeshBasicMaterial({opacity: 0, transparent: true})
    // let dianMaterial2 = new THREE.MeshBasicMaterial({opacity: 0})
    var list = []
    for (var k = 1; k < 6; k++) {
      list.push(loadmodel.scene.getObjectByName('s4_dian_' + k))
    }
    var dianBox
      // console.log(list.length)
    for (var j = 0; j < list.length; j++) {
      dianBox = new THREE.Mesh(new THREE.SphereBufferGeometry(r / 12, 60, 40), dianMaterial)
      dianBox.position.set(list[j].position.x, list[j].position.y, list[j].position.z)
      // dianBox2 = new THREE.Mesh(new THREE.SphereBufferGeometry(r / 36, 60, 40), dianMaterial2)
      // dianBox2.position.set(list[j].position.x, list[j].position.y, list[j].position.z)
      dianBox.name = 's4_dian' + j
      // pano.add(dianBox2)
      pano.add(dianBox)
    }
      // console.log(pano)

    let textures = this.getTexturesFromAtlasFile('static/images/p2/', 'jpg')
    let materials = []
    for (var i = 0; i < 6; i++) {
      materials.push(new THREE.MeshBasicMaterial({map: textures[i]}))
    }
    var skyBox = new THREE.Mesh(new THREE.CubeGeometry(r * 1.5, r * 1.5, r * 1.5), materials)
    skyBox.geometry.scale(-1, 1, 1)
    skyBox.position.set(position.x, position.y, position.z)
    skyBox.rotation.y = Math.PI
    skyBox.name = 's4_pano'
    skyBox.visible = true
    pano.add(skyBox)
    let materialdoor1 = new THREE.MeshBasicMaterial({opacity: 0, transparent: true, color: 0xffffff})
    let OutDoor = loadmodel.scene.getObjectByName('s4_out_1')
    let geometryo = new THREE.SphereBufferGeometry(r / 6, 30, 30)
    let mesho = new THREE.Mesh(geometryo, materialdoor1)
    mesho.position.set(OutDoor.position.x, OutDoor.position.y, OutDoor.position.z)
    mesho.name = 's4_door'
    pano.add(mesho)
  }

  getTexturesFromAtlasFile (atlasImgUrl, tilesNum) {
    atlasImgUrl = 'static/images/p2/all2.jpg'
    tilesNum = 6
    var textures = []
    for (var i = 0; i < tilesNum; i++) {
      textures[i] = new THREE.Texture()
    }
    var imageObj = new Image()
    imageObj.onload = function () {
      var canvas, context
      var tileWidth = imageObj.height
      for (var i = 0; i < textures.length; i++) {
        canvas = document.createElement('canvas')
        context = canvas.getContext('2d')
        canvas.height = tileWidth
        canvas.width = tileWidth
        context.drawImage(imageObj, tileWidth * i, 0, tileWidth, tileWidth, 0, 0, tileWidth, tileWidth)
        textures[i].image = canvas
        textures[i].needsUpdate = true
      }
    }
    imageObj.src = atlasImgUrl
    return textures
  }

  // getTexturesFromAtlasFile (atlasImgUrl, type) {
  //   var textures = []
  //   var url = []
  //   url[0] = atlasImgUrl + 1 + '.' + type
  //   url[1] = atlasImgUrl + 3 + '.' + type
  //   url[2] = atlasImgUrl + 4 + '.' + type
  //   url[3] = atlasImgUrl + 5 + '.' + type
  //   url[4] = atlasImgUrl + 0 + '.' + type
  //   url[5] = atlasImgUrl + 2 + '.' + type
  //   let that = this
  //   for (var i = 0; i < 6; i++) {
  //     textures[i] = new THREE.Texture()
  //     textures[i] = that.getSigleTexture(textures[i], url[i])
  //   }
  //   return textures
  // }

  getSigleTexture (Texture, image) {
    var imageObj = new Image()
    imageObj.onload = function () {
      var canvas, context
      var tileWidth = imageObj.height
      canvas = document.createElement('canvas')
      context = canvas.getContext('2d')
      canvas.height = tileWidth
      canvas.width = tileWidth
      context.drawImage(imageObj, 0, 0, tileWidth, tileWidth, 0, 0, tileWidth, tileWidth)
      Texture.image = canvas
      Texture.needsUpdate = true
    }
    imageObj.src = image
    return Texture
  }
}
export default Scene3



// WEBPACK FOOTER //
// ./src/js/views/Scene3.js